import * as types from "./mutation-types";

export default {
  [types.SET_USERS](state, payload) {
    state.users = payload;
  },
  [types.SET_USER](state, payload) {
    state.user = payload;

    if(payload && payload.cliente){
      state.user.cliente_id = payload.cliente.id
    }
  },
  [types.SET_PAGINATION](state, payload) {
    state.pagination = payload;
  }
};
